<template>
  <div class="coop-c-survey-step">
    <a
      class="coop-t-link"
      href="#"
      @click.prevent="surveyStore.nextStep(-1)"
    >
      <span class="coop-t-link__icon">
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_357_6310)">
            <path
              d="M8.75984e-08 7.34586C8.82315e-08 7.39894 8.88158e-08 7.44794 8.88158e-08 7.44794L8.94488e-08 7.50102C9.00818e-08 7.5541 -8.63008e-07 7.6031 0.04875 7.65619C0.04875 7.70927 0.0975009 7.75827 0.1425 7.81135L6.55875 14.8469C6.74625 15.051 7.03125 15.051 7.21875 14.8469C7.40625 14.6427 7.40625 14.3324 7.21875 14.1282L1.605 8.01552L14.5275 8.01552C14.8088 8.01552 15 7.81135 15 7.50102C15 7.19477 14.8125 6.98652 14.5275 6.98652L1.55625 6.98652L7.07625 0.873826C7.26375 0.669661 7.26375 0.35933 7.07625 0.155165C6.9825 0.053083 6.88875 9.67257e-08 6.74625 9.8425e-08C6.60375 1.00124e-07 6.51 0.053083 6.41625 0.155165L0.0937501 7.14169C0.0937501 7.19477 0.04875 7.24377 8.75984e-08 7.34586C8.75984e-08 7.34586 8.70141e-08 7.29686 8.75984e-08 7.34586Z"
              fill="#00729A"
            />
          </g>
          <defs>
            <clipPath id="clip0_357_6310">
              <rect
                width="15"
                height="15"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
      </span>Back
    </a>
    <h2
      id="prepared-heading"
      class="coop-u-margin-resp-t-32-16 coop-u-margin-resp-b-48-24"
    >
      How prepared do you feel for retirement?
    </h2>
    <div class="coop-l-grid">
      <div class="coop-l-grid__item coop-l-grid__item--large-12">
        <div class="coop-c-icon-select">
          <div
            v-for="option in surveyStore.options.prepared"
            :key="option.value"
            class="coop-c-icon-select__item coop-u-padding-resp-32-16 coop-u-flex coop-u-flex-column"
            :class="{'coop-c-icon-select__item--selected': surveyStore.surveyResult.prepared === option.value}"
          >
            <div class="coop-c-icon-select__item-image coop-u-margin-resp-b-32-16">
              <img
                :src="option.image"
                :alt="option.label"
              >
            </div>
            <span
              :id="`icon-select-${option.value}`"
            >{{ option.label }}</span>
            <a
              href="#"
              class="coop-c-icon-select__item-link"
              aria-label="Select {{ option.label }}"
              @click.prevent="surveyStore.surveyResult.prepared = option.value"
              @keydown.space.prevent="surveyStore.surveyResult.feel = option.value"
            />
          </div>
        </div>
        <p
          v-if="error"
          id="prepared-error"
          class="coop-form__error"
        >
          {{ error }}
        </p>

        <div class="coop-u-margin-t-64 coop-p-retirement-survey__actions">
          <button
            class="coop-btn coop-btn--primary"
            @click.prevent="next"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
// eslint-disable-next-line import/no-unresolved
import { useSurveyStore } from '@/stores/survey.js';

const surveyStore = useSurveyStore();
const error = ref(null);

const next = () => {
  if (!surveyStore.surveyResult.prepared) {
    error.value = 'Please select an option';
    return;
  }

  window.dataLayer.push({
    event: 'Survey',
    step: 5,
    selected: surveyStore.options.prepared.find(
      (option) => option.value === surveyStore.surveyResult.prepared,
    ).label,
  });

  surveyStore.nextStep();
};
</script>
